import {createContext, Context} from 'react';
import type {SyncPath, Params} from './types';


export type RouteContextValue = {
  pathname: string;
  path: SyncPath;
  params: Params;
};

// @ts-expect-error - TS2322 - Type 'Context<{ pathname: string; path: never[]; params: {}; }>' is not assignable to type 'Context<RouteContextValue>'.
export const RouteContext: Context<RouteContextValue> = createContext({
  pathname: '',
  path: [],
  params: {},
});
